module.exports = __webpack_public_path__ + "static/media/chalkboard.2521cfc0.jpg";